import formatDate from "@/client/helpers/formatDate";
import parseDate  from "@/client/helpers/parseDate";
import startOfDay from "date-fns/startOfDay";

const now = +startOfDay(new Date());

export const renderDeviceOperationStartDate = ( operationStartDate ) => {
  if (!operationStartDate) return '-';
  return formatDate(operationStartDate);
};

export const renderDeviceOperationStartDateCell = ( operationStartDate ) => {
  if (!operationStartDate) return '-';
  const date = startOfDay(parseDate(operationStartDate));
  const formattedDate = formatDate(date);
  if (date <= now) return formattedDate;
  const style = `background: rgb(246, 193, 81);position: absolute; top: -1px; left: 0;  width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;`;
  const title = 'Дата в будущем';
  return `<span style="${style}" title="${title}">${formattedDate}</span>`;
};
